export default {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  paddingTop: '3.5em',
  width: '100%',
  height: '100%',
  borderRadius: 'small',
  boxShadow: 'level1',
};
